/// <amd-module name="Widgets/SprintBurndownConfig/Pickers/TeamsPickerHelper" />
import { TeamInfo, TeamsQuery } from "Analytics/Boards/BoardsQueries/TeamsQuery";
import { ICacheableQueryService } from "Dashboards/WidgetCommon/DashboardsCacheableQueryService";
import { IVssPageContext } from "VSS/Platform/Context";
import { IListBoxItem } from "VSSUI/ListBox";

export async function getTeamListItems(pageContext: IVssPageContext, projectId: string): Promise<IListBoxItem<TeamInfo>[]> {
    const queryCache = pageContext.getService<ICacheableQueryService>("IDashboardsCacheableQueryService");
    const teams = await queryCache.getCacheableQueryResult(TeamsQuery.onProject(pageContext, projectId));
    const teamItems = teams.map(team => {
        const teamItem: IListBoxItem<TeamInfo> = {
            data: team,
            id: team.TeamId,
            text: team.TeamName
        };
        return teamItem;
    });
    return teamItems;
}
